import * as React from 'react';

import {RemoveButton} from 'shells/button/remove-button/remove-button';
import {Card} from 'shells/card/card';
import {StaticTwoLineWithIcon} from 'shells/list-row/static-two-line-with-icon';

import styles from './selected-field-card.module.css';

type Props = {
    title: string | React.ReactNode;
    subtitle: string | React.ReactNode;
    icon: React.ComponentType<any> | React.ReactNode;
    onRemove: () => void;
};

export function SelectedFieldCard(props: Props) {
    return (
        // @ts-expect-error
        <Card hasBorder={true} isFullWidth={true} fitHeight={true}>
            <div className={styles.content}>
                <StaticTwoLineWithIcon
                    title={props.title}
                    subtitle={props.subtitle}
                    icon={props.icon}
                />
                <RemoveButton onClick={props.onRemove} size={12} />
            </div>
        </Card>
    );
}
